/**
 * CoinIcon — sembol ya da slug verilince renkli coin logosunu döner.
 * CDN: cryptocurrency-icons v0.18.1 (JsDelivr)
 * Coin yoksa renkli initial (örn. "B" turuncu) gösterilir.
 */
const CDN = "https://cdn.jsdelivr.net/npm/cryptocurrency-icons@0.18.1/svg/color";

// Bilinen sembol → renk haritası (fallback için)
const COLORS = {
  BTC: "#f7931a", ETH: "#627eea", BNB: "#f3ba2f", SOL: "#14b88a",
  XRP: "#5a6472", ADA: "#0a4fd6", DOGE: "#c2a633", TRX: "#ff3b3b",
  AVAX: "#e84142", LINK: "#2a5ada", MATIC: "#8247e5", LTC: "#bfbbbb",
  DOT: "#e6007a", USDT: "#26a17b",
};

const sizeMap = { sm: 18, md: 22, lg: 28, xl: 36 };

export default function CoinIcon({
  symbol,
  size = "md",
  className = "",
  testId,
}) {
  const sym = String(symbol || "").replace(/USDT$/i, "").toUpperCase();
  const slug = sym.toLowerCase();
  const px = sizeMap[size] || size;
  const color = COLORS[sym] || "#6b7280";

  return (
    <span
      className={`coin-ic ${className}`}
      data-testid={testId || `coin-ic-${sym}`}
      style={{
        width: px,
        height: px,
        borderRadius: "50%",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        background: `${color}22`,
        flexShrink: 0,
        position: "relative",
      }}
    >
      <img
        alt={sym}
        src={`${CDN}/${slug}.svg`}
        width={px - 2}
        height={px - 2}
        loading="lazy"
        onError={(e) => {
          // CDN'de yoksa initial göster
          e.currentTarget.style.display = "none";
          if (e.currentTarget.nextSibling) {
            e.currentTarget.nextSibling.style.display = "flex";
          }
        }}
        style={{ display: "block" }}
      />
      <span
        style={{
          display: "none",
          position: "absolute",
          inset: 0,
          alignItems: "center",
          justifyContent: "center",
          fontFamily: "var(--fm)",
          fontSize: Math.max(8, px * 0.38),
          fontWeight: 700,
          color,
          letterSpacing: 0.3,
        }}
        aria-hidden
      >
        {sym.slice(0, 2)}
      </span>
    </span>
  );
}
